import isEmpty from 'lodash/isEmpty';
import { hasValue } from "../../../../../../general/js/general-helpers";
import { formConstants } from "../../../utils/constants/form-constants";

export const getMainAddress = (currentUser) => {
    if (!currentUser || !currentUser.addresses) {
        return null;
    }

    return  currentUser.addresses.find((e) => e.main);
};

export const getPropertyFromMainAddress = (mainAddres, propertyName) => {
    if (!mainAddres) {
        return null;
    }

    return mainAddres[propertyName];
};

export const getTitle = ( currentUser ) =>
{
    if ( !currentUser || !currentUser.title )
    {
        return null;
    }
    return currentUser.title;
}

export const getDateOfBirth = ( currentUser ) =>
{
    if ( !currentUser || !currentUser.dateOfBirth )
    {
        return null;
    }
    
    const { dateOfBirthDay, dateOfBirthMonth, dateOfBirthYear } = currentUser;
    const dayAsNumber = parseInt(dateOfBirthDay, 10);
    const monthAsNumber = parseInt(dateOfBirthMonth, 10);
    const yearAsNumber = parseInt(dateOfBirthYear, 10);
    
    return {
        year: yearAsNumber,
        month: monthAsNumber,
        day: dayAsNumber
    };
}

export const getMobilePhone = ( formData, formConstants ) =>
{
    if ( !formData.currentUser || !formData.currentUser.mobilePhone || !formData.currentUser.countryCodeMobilePhonePrefix)
    {
        return null;
    }

    const userMobilePhone = formData.currentUser.mobilePhone;

    const selectedCountry = getSelectedCountry(formData, formConstants);

    if (!hasValue(selectedCountry)){
        return null;
    }

    return {
        phoneNumber: userMobilePhone.replace(selectedCountry.phonePrefix, ''),
        selectedCountry: selectedCountry
    };
}

export const hasOneClubRequiredFields = (currentUser, optIns) => 
{
    const title = getTitle(currentUser);
    const mainAddress = getMainAddress(currentUser);
    const dateOfBirth = getDateOfBirth(currentUser);

    if (!hasValue(title) || !hasValue(mainAddress) || !hasValue(dateOfBirth)
         || optIns.agreedToTermsAndConditions === undefined || optIns.agreedToTermsAndConditions === false
         || optIns.agreedToPrivacyPolicy === undefined || optIns.agreedToPrivacyPolicy === false)
    {
        return false;
    }

    if (hasValue(mainAddress))
    {
        const country = getPropertyFromMainAddress(mainAddress, formConstants.country);
       
        if (!hasValue(country))
        {
            return false;
        }
    }
    
    return true;
}

function getSelectedCountry(formData, formConstants) {
    let selectedCountry = null;

    if(isFormDataCountryOptionsAvailable(formData, formConstants)){
        selectedCountry = formData[formConstants.country].options
        .find((country) => !isEmpty(country.phonePrefix) &&
            country.code === formData.currentUser.countryCodeMobilePhonePrefix);
    }

    if (hasValue(selectedCountry))
        return selectedCountry;

    if(isFormDataCountryOptionsAvailable(formData, formConstants)){
        selectedCountry = formData[formConstants.country].options
        .find((country) => !isEmpty(country.phonePrefix) &&
            formData.currentUser.mobilePhone.includes(country.phonePrefix));
    }

    return selectedCountry;
}

const isFormDataCountryOptionsAvailable = (formData, formConstants) => {
    return hasValue(formData) && hasValue(formConstants) && hasValue(formData[formConstants.country]) && hasValue(formData[formConstants.country].options)
}
